














import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import Container from '@/components/layout/Container.vue';
import LocaleSelectSolo from '@/components/common/LocaleSelectSolo.vue';
import InstallPrompt from '@/components/common/InstallPrompt.vue';
import FlatButton from '@/components/common/FlatButton.vue';

import InstallMixin from '@/mixins/install';

@Component({
  components: { InstallPrompt, FlatButton, LocaleSelectSolo, Container },
})
export default class HeadBannerNav extends mixins(InstallMixin) {
  handleInstall() {
    this.promptInstall();
  }
}
